/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProfileUnsubscribeIdGet$Params {

/**
 * The unique identifier of the profile to unsubscribe
 */
  id: string;
}

export function profileUnsubscribeIdGet(http: HttpClient, rootUrl: string, params: ProfileUnsubscribeIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, profileUnsubscribeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VivaLiteScanStrictHttpResponse<void>;
    })
  );
}

profileUnsubscribeIdGet.PATH = '/Profile/Unsubscribe/{id}';
